import { render, staticRenderFns } from "./ViewSettingView.vue?vue&type=template&id=3c87fd85"
import script from "./ViewSettingView.vue?vue&type=script&lang=js"
export * from "./ViewSettingView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports